/**
 * @auth 赖传峰
 * @date 2022/3/28
 */
import { defineStore } from 'pinia'

interface LayoutState {
  sidebarMobileVisible: boolean
  i18nMenuPopoverVisible: boolean
  isMobile: boolean
  darkMode: boolean
  serverTime: number
  /** 折叠模式: Footer 将会收起 */
  isCollapse: boolean
}

export const useLayout = defineStore<'layout', LayoutState>('layout', {
  state: () => ({
    sidebarMobileVisible: false,
    i18nMenuPopoverVisible: false,
    isMobile: false,
    darkMode: false,
    serverTime: new Date().getTime(),
    isCollapse: false,
  }),
})
